import type { MessageKey } from '../i18n/messages';

type TranslateFn = (key: MessageKey, params?: Record<string, string | number>) => string;

/** Spoken + on-screen hit count after a search settles. */
export function formatAssistantFoundCount(count: number, t: TranslateFn): string {
  const n = Math.max(0, Math.floor(count));
  if (n === 1) {
    return t('assistant.result.foundCountOne');
  }
  return t('assistant.result.foundCount', { count: n });
}

/** Append found-count to a search summary (also spoken by the speaker toggle). */
export function withAssistantFoundCount(summary: string, count: number, t: TranslateFn): string {
  const found = formatAssistantFoundCount(count, t);
  const base = summary.trim().replace(/\s*…\s*$/, '').replace(/[.。]\s*$/, '');
  if (!base) {
    return found;
  }
  return `${base}. ${found}`;
}
